import React from 'react';
import { GridItem, Row } from '../../../../ui';
import ArrowIcon from '../../../../ui/new-assets/arrow.svg';
import { Button } from '../../../../ui/new-components/Button';
import { FooterSectionHeader } from './FooterSectionHeader';

export interface IFooterButtonSectionProps {
	title: string;
	buttons: IFooterButton[];
}

export interface IFooterButton {
	title: string;
	link: string;
}

export const FooterButtonSection = ({
	title,
	buttons,
}: IFooterButtonSectionProps) => (
	<GridItem columns={[6, { mobileXL: 12 }]}>
		<FooterSectionHeader styling="h3">{title}</FooterSectionHeader>

		<Row columns={[2, { tablet: 1 }]}>
			{buttons.map((button) => (
				<Button
					variant="secondary"
					href={button.link}
					key={button.link}
					icon={<ArrowIcon aria-hidden />}
					className="w-[264px] mobile-xl:w-full"
				>
					{button.title}
				</Button>
			))}
		</Row>
	</GridItem>
);
